<template>
  <svg :aria-label="ariaLabel" :class="iconSizeClass" :data-qa="dataQA" :aria-hidden="ariaHidden" role="img" data-name="Fax Outbound" class="d-icon d-icon--fax-outbound" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12"><path fill="currentColor" d="M8.738 6.38a.5.5 0 0 1 .5.5v1.31h.405a.405.405 0 0 0 .405-.404v-2.31a.5.5 0 1 1 1 0v2.31A1.406 1.406 0 0 1 9.643 9.19h-.405v1.31a.5.5 0 0 1-.5.5H3.31a.5.5 0 0 1-.5-.5V9.19h-.406A1.405 1.405 0 0 1 1 7.786V5.523A1.405 1.405 0 0 1 2.404 4.12v1A.405.405 0 0 0 2 5.523v2.263a.405.405 0 0 0 .404.404h.406V6.88a.5.5 0 0 1 .5-.5h5.428ZM3.81 10h4.428V7.38H3.81V10ZM6.25.952a.5.5 0 0 1 0 1H3.81V4.12h2.44a.5.5 0 0 1 0 1H2.405v-1h.405V1.452a.5.5 0 0 1 .5-.5h2.94Zm5.25 2.762a.5.5 0 0 1-1 0V2.207l-1.86 1.86a.5.5 0 1 1-.707-.707l1.86-1.86H8.286a.5.5 0 0 1 0-1H11a.5.5 0 0 1 .5.5v2.714Z"/></svg>
</template>

<script>
import { ICON_SIZE_MODIFIERS } from '@/src/constants';

export default {
  name: 'DtIconFaxOutbound',

  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: [String, Number],
      default: 500,
      validator: (s) => Object.keys(ICON_SIZE_MODIFIERS).includes(String(s)),
    },

    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: undefined,
    },
  },

  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ['loaded'],

  computed: {
    iconSizeClass () {
      return ICON_SIZE_MODIFIERS[this.size];
    },

    ariaHidden () {
      return !this.ariaLabel ? 'true' : 'false';
    },

    dataQA () {
      return this.$attrs['data-qa'] ?? 'dt-icon';
    },
  },

  created () {
    this.$emit('loaded');
  },
};
</script>
